import { colors } from "../Styles";
import { AttentionTypes } from "./valueTypes";

export const CreateAttentionStyles = (t: (key: string) => string, attentionType?: string) => {
  let textColor = "";
  let attentionText = "";
  let secondaryAttentionText = "";
  let attentionColor = "";

  switch (attentionType) {
    case AttentionTypes.good:
      textColor = colors.greyLightTertiary;
      attentionText = t(`systemControls.states.${AttentionTypes.good}`);
      attentionColor = colors.systemGreen;
      break;
    case AttentionTypes.warning:
      textColor = colors.greyDarkPrimary;
      attentionText = t(`systemControls.states.${AttentionTypes.warning}`);
      secondaryAttentionText = t("systemControls.general.warnings");
      attentionColor = colors.systemYellow;
      break;
    case AttentionTypes.alert:
      textColor = colors.greyLightTertiary;
      attentionText = t(`systemControls.states.${AttentionTypes.alert}`);
      secondaryAttentionText = t("systemControls.general.alerts");
      attentionColor = colors.systemRed;
      break;
    case AttentionTypes.neutral:
    default:
      textColor = colors.greyLightTertiary;
      attentionText = t(`systemControls.states.${AttentionTypes.neutral}`);
      attentionColor = colors.blackPrimary;
      break;
  }

  return { textColor, attentionText, attentionColor, secondaryAttentionText };
};
